import { toDateTime, cpfCnpjMask } from "Helpers/Format";

export const usersColumns = [
  {
    Header: "ID",
    accessor: "id",
  },
  {
    Header: "Nome",
    accessor: "full_name",
  },
  {
    Header: "E-mail",
    accessor: "email",
  },
  {
    Header: "Documento",
    accessor: (row) => (row.document ? cpfCnpjMask(row.document) : ""),
  },
  {
    Header: "Cargo",
    accessor: "role",
  },
  {
    Header: "Último Login",
    accessor: (row) => (row.last_login ? toDateTime(row.last_login) : ""),
  },
  {
    Header: "Status",
    accessor: (row) => (row.inactivated_at ? "Inativo" : "Ativo"),
  },
];
